import { constants as c, selectors as imported } from '../imports'
import { OUTDATED, fetching, fetched } from '../data'
import { fetchAds } from '../data/api'

function fetch(store) {
    const state = store.getState()
    const locale = imported.getLocale(state)
    const isSteam = imported.isSteamStartup(state)

    // Let know that I am fetching
    store.dispatch(fetching())

    fetchAds(isSteam, locale)
        .then((creatives) => {
            // Update the state with the new creatives
            store.dispatch(fetched(creatives))
        })
        .catch((error) => {
            console.info(`Error occurred while fetching creatives content: ${error.message}`)
        })
}

const CreativesMiddleware = store => next => (action) => {
    switch (action.type) {
        case OUTDATED:
        case c.LOCALE_CHANGED:
        case c.STEAM_CHANGED: {
            const result = next(action)
            fetch(store)
            return result
        }

        default:
            return next(action)
    }
}

export default CreativesMiddleware



// WEBPACK FOOTER //
// ./src/features/Creatives/middleware/index.js